import { Container, Box } from "@material-ui/core";
import { useHistory, useLocation } from "react-router-dom";
import React from "react";
import { FTLTypography } from "../FTLTypography";
import { FTLButton } from "../FTLButton";
export { FTLErrorBoundary } from "./FTLErrorBoundary";
const messageToVariant = {
    notExist: "Пожалуйста, выполните вход повторно",
    expiredToken: "Пожалуйста, выполните вход повторно",
    accessDenied: "Недостаточно прав для доступа. Обратитесь к администратору сервиса или вернитесь в предыдущий раздел",
    userIsBlocked: "Обратитесь к администратору",
    internalError: (React.createElement(React.Fragment, null,
        React.createElement("div", null, "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u0430\u0442\u044C \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435."),
        React.createElement("div", null, "\u041C\u044B \u043F\u043E\u0434\u0433\u043E\u0442\u043E\u0432\u0438\u043B\u0438 \u043E\u0442\u0447\u0451\u0442 \u0438 \u043E\u0442\u043F\u0440\u0430\u0432\u0438\u043B\u0438 \u0435\u0433\u043E \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u0447\u0438\u043A\u0430\u043C."))),
    internalErrorWithRefresh: (React.createElement(React.Fragment, null,
        React.createElement("div", null, "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u0430\u0442\u044C \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435."),
        React.createElement("div", null, "\u041C\u044B \u043F\u043E\u0434\u0433\u043E\u0442\u043E\u0432\u0438\u043B\u0438 \u043E\u0442\u0447\u0451\u0442 \u0438 \u043E\u0442\u043F\u0440\u0430\u0432\u0438\u043B\u0438 \u0435\u0433\u043E \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u0447\u0438\u043A\u0430\u043C."))),
};
const titleToVariant = {
    notExist: "Ошибка доступа",
    expiredToken: "Ошибка доступа",
    accessDenied: "Доступ запрещён",
    userIsBlocked: "Аккаунт заблокирован",
    internalError: "Произошла ошибка",
    internalErrorWithRefresh: "Произошла ошибка",
};
const buttonComponent = (variant, history) => {
    switch (variant) {
        case "internalError":
        case "accessDenied":
            return (React.createElement(FTLButton, { onClick: () => history.goBack(), color: "primary" }, "\u0412\u0435\u0440\u043D\u0443\u0442\u044C\u0441\u044F \u043D\u0430\u0437\u0430\u0434"));
        case "notExist":
            return (React.createElement(FTLButton, { onClick: () => history.push("/"), color: "primary" }, "\u0412\u043E\u0439\u0442\u0438"));
        case "internalErrorWithRefresh":
            return (React.createElement(FTLButton, { onClick: () => location.reload(), color: "primary" }, "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443"));
        default:
            return null;
    }
};
export const FTLErrorPage = ({ hasError, title = "Что-то пошло не так...", variant = "default", buttons, message, children, }) => {
    var _a, _b;
    const history = useHistory();
    const { state, } = useLocation();
    return hasError ? (React.createElement(Container, { maxWidth: "xs" },
        React.createElement(Box, { display: "flex", mt: variant === "userIsBlocked" ? 24 : 4, alignItems: "center", flexDirection: "column", justifyContent: "center" },
            React.createElement(FTLTypography, { variant: "h1" }, ((_a = state === null || state === void 0 ? void 0 : state.title) !== null && _a !== void 0 ? _a : variant === "default")
                ? title
                : titleToVariant[variant]),
            React.createElement(Box, { mt: 3, maxWidth: "500px" },
                React.createElement(FTLTypography, { align: "center", variant: "p3", display: "block" }, ((_b = state === null || state === void 0 ? void 0 : state.message) !== null && _b !== void 0 ? _b : variant === "default")
                    ? message
                    : messageToVariant[variant])),
            React.createElement(Box, { mt: 6, display: "flex" },
                buttons,
                buttonComponent(variant, history))))) : (React.createElement(React.Fragment, null, children));
};
export default FTLErrorPage;
//# sourceMappingURL=index.js.map